import { useState } from "react";
import { Trans } from "react-i18next";
import { IconLineAI } from "@kalodata/kds-design-icons";
import { SelectCharacterModal } from "./SelectCharacterModal";
import { StudioSectionLabel } from "./StudioSectionLabel";
import { useVideoRemakeStudio } from "./VideoRemakeStudioContext";
import { IconFolder } from "@icons/index";

export const OnCameraCharactersSection = () => {
  const { characterMode, setCharacterMode, selectedCharacter, pickCharacter } = useVideoRemakeStudio();
  const [open, setOpen] = useState(false);

  const activeClass =
    "flex cursor-pointer items-center gap-[6px] overflow-hidden rounded-[8px] border border-kds-accent bg-kds-accent-soft h-[32px] px-[12px] py-[6px] text-[14px] font-medium leading-[16px] text-kds-accent-fg outline-none";
  const inactiveClass =
    "flex cursor-pointer items-center gap-[6px] overflow-hidden rounded-[8px] border border-kds-border-solid bg-kds-bg-element h-[32px] px-[12px] py-[6px] text-[14px] font-medium leading-[16px] text-kds-muted outline-none";

  return (
    <section className="flex w-full flex-col gap-[8px]">
      <StudioSectionLabel>
        <Trans>Character</Trans>
      </StudioSectionLabel>
      <div className="flex items-center gap-[8px]">
        <button
          type="button"
          onClick={() => setCharacterMode("auto")}
          className={characterMode === "auto" ? activeClass : inactiveClass}
        >
          <IconLineAI size={20} />
          <Trans>Auto-generate</Trans>
        </button>
        <button
          type="button"
          onClick={() => {
            setCharacterMode("designated");
            setOpen(true);
          }}
          className={characterMode === "designated" ? activeClass : inactiveClass}
        >
          <IconFolder className="w-[20px] h-[20px]" />
          <Trans>Custom Character</Trans>
        </button>
      </div>
      <SelectCharacterModal
        open={open}
        onClose={() => setOpen(false)}
        onSelect={pickCharacter}
        selectedId={selectedCharacter?.id ?? null}
      />
    </section>
  );
};
